import { render } from "./layout.vue?vue&type=template&id=cd183b70&scoped=true"
import script from "./layout.vue?vue&type=script&lang=js"
export * from "./layout.vue?vue&type=script&lang=js"

import "./layout.vue?vue&type=style&index=0&id=cd183b70&lang=scss&scoped=true"

import exportComponent from "/builds/springup/oa-front/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-cd183b70"]])

export default __exports__